import { Redirect, Route, Switch } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Application, Loading } from '@fides/fides-react-components';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';

const Impersonation = React.lazy(() => import('../../components/pages/Impersonation'));

const ChangePassword = React.lazy(() => import('../../components/pages/ChangePassword'));
const Settings = React.lazy(() => import('../../components/pages/Settings'));

export const UserRouter = () => {
  const { accessHelper } = useGlobalConfigContext();
  const hasAccessToImpersonation =
    (accessHelper.isFidesAdministrator(Application.EFTWEB) ||
      accessHelper.isFidesReadOnlyAdministrator(Application.EFTWEB)) &&
    !accessHelper.isImpersonated;

  return (
    <Switch>
      <Route path='/user/change-password' exact>
        <Suspense fallback={<Loading />}>
          <ChangePassword />
        </Suspense>
      </Route>
      <Route path='/user/settings' exact>
        <Suspense fallback={<Loading />}>
          <Settings />
        </Suspense>
      </Route>
      <Route path='/user/impersonation' exact>
        <Suspense fallback={<Loading />}>
          {hasAccessToImpersonation ? <Impersonation /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
